module.exports = __webpack_public_path__ + "static/media/03_05_03.26a1d04a.png";